import { AppleLogoIcon, WindowsLogoIcon } from '@phosphor-icons/react';
import { buttonStyles } from '../../ui';
import { ShipNodeDownloads, ShipNodeProductionComingSoon } from './links';
import type { ShipNodeChannel } from './types';

/** "Don't have ShipNode yet?": the latest Windows and Mac installers for this environment. */
export function Downloads({ channel }: { channel: ShipNodeChannel }) {
  const isProd = channel === 'production';

  return (
    <div className="sk:flex sk:flex-col sk:items-center sk:gap-3 sk:text-center">
      <p className="sk:m-0 sk:text-sm sk:font-semibold sk:text-fg">
        Don't have ShipNode yet?
      </p>
      {isProd && ShipNodeProductionComingSoon ? (
        <p role="note" className="sk:m-0 sk:text-dense sk:text-fg-secondary">
          ShipNode is coming soon.
        </p>
      ) : (
        <p className="sk:m-0 sk:text-dense sk:text-fg-tertiary">
          Install it on the packing PC, then add the station here.
        </p>
      )}
      <div className="sk:flex sk:flex-wrap sk:justify-center sk:gap-2">
        <a
          href={ShipNodeDownloads.windows[channel]}
          className={buttonStyles({ className: 'sk:no-underline' })}
          download
        >
          <WindowsLogoIcon size={16} />
          Windows
        </a>
        <a
          href={ShipNodeDownloads.mac[channel]}
          className={buttonStyles({ className: 'sk:no-underline' })}
          download
        >
          <AppleLogoIcon size={16} />
          Mac
        </a>
      </div>
    </div>
  );
}
